import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { pathNameKeygen, loadCouponRecommendations, refreshItems } from '../../actions'
import BetsList from './BetsList'
import RecommendationsList from './RecommendationsList'
import { smallTableBetsColumns, couponColumns } from '../../settings'
import './Recommendations.css'

import get from 'lodash/get'
import forEach from 'lodash/forEach'
import keys from 'lodash/keys'


class CouponsPage extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      couponIndex: 0,
      timeRange: 30,
      recommendationsType: 'personalized',
      isDirty: false,
    }
  }

  _showPreviousCoupon = (e) => {
    this._setCouponIndex(this.state.couponIndex - 1)
  }

  _showNextCoupon = (e) => {
    this._setCouponIndex(this.state.couponIndex + 1)
  }

  _setCouponIndex(index) {
    const MAX_COUPON_INDEX = 25;
    const {refreshItems} = this.props;

    let nextCouponIndex = index;
    if (nextCouponIndex >= MAX_COUPON_INDEX) {
      nextCouponIndex = 0;
    } else if(nextCouponIndex < 0) {
      nextCouponIndex = MAX_COUPON_INDEX;
    }

    this.setState({couponIndex: nextCouponIndex})
    refreshItems('betRecommendations')
  }

  _handleTimeChange = (e) => {
    this.setState({timeRange: parseInt(e.target.value, 10), isDirty: true});
  }

  _handleTimeSubmit = (e) => {
    const {refreshItems} = this.props;
    refreshItems('betRecommendations')
    e.preventDefault();

    this.setState({isDirty: false})
  }

  _handleOptionChange = (e) => {
    this.setState({recommendationsType: e.target.value, isDirty: true});
  }

  render() {
    const {couponIndex, timeRange, recommendationsType, isDirty} = this.state
    const { player } = this.props
    const beforeDate = moment().add(timeRange, 'hours').format('YYYY-MM-DDTHH:mm:ss')

    return (
      <div className="recommendations-page">
        <div className="hbox hbox--vtop">
          <div className="bet-list hbox--flex">
            <h3 className="table-title">
              Recent betting activity
            </h3>
            <BetsList 
              {...this.props}
              columns={smallTableBetsColumns} />
          </div>
          <div className="bet-list hbox--flex">
            <h3 className="table-title hbox hbox--vcenter">
              <a className="hbox--flex"
                 href={`/api/tipico/mybetslip/?user_id=${get(player, 'uuid')}&before_date=${beforeDate}&num_context_events=${couponIndex+1}`}>
                Coupon
              </a>

              <form onSubmit={this._handleTimeSubmit}>
                <div className="time-range-input-container hbox hbox--vcenter">
                  <div className="header-form-radio">
                    <label className="hbox hbox--vcenter">
                      <input 
                        type="radio"
                        value="personalized"
                        checked={recommendationsType === 'personalized'} 
                        onChange={this._handleOptionChange} />
                      personalized
                    </label>
                  </div>
                  <div className="header-form-radio">
                    <label className="hbox hbox--vcenter">
                      <input 
                          type="radio"
                          value="popular"
                          checked={recommendationsType === 'popular'} 
                          onChange={this._handleOptionChange} />
                        popular
                    </label>
                  </div>
                  <input className='time-range-input' type="text" value={timeRange} onChange={this._handleTimeChange} />
                  <input className='time-range-submit' type="submit" value="ok" disabled={isDirty ? "" : "disabled"} />
                </div>
              </form>
              

              <span className="pager hbox">
                <i className="pager-button fas fa-angle-double-left" onClick={this._showPreviousCoupon}></i>
                <span className="pager-text">Coupon {couponIndex + 1}</span>
                <i className="pager-button fas fa-angle-double-right" onClick={this._showNextCoupon}></i>
              </span>
            </h3>

            <RecommendationsList
              {...this.props}
              rowHeight={100}
              keygen={pathNameKeygen}
              loadItems={loadCouponRecommendations}
              columns={couponColumns}
              couponIndex={this.state.couponIndex}
              recommendationsType={this.state.recommendationsType}
              beforeDate={beforeDate} />
          </div>
        </div>
      </div>
    )
  }
}

const calculateHits = function(state, bets, recommendations) {
  if(!bets || !recommendations) { return {} }

  const betEventIds = {}
  forEach(bets.pages, (page, index) => {
    forEach(page.ids, id => {
      betEventIds[state.entities.bets[id].event_id] = true
    })
  })

  const hits = {}
  forEach(recommendations.pages, (page, index) => {
    forEach(page.ids, id => {
      // bet recommendation id is the event id
      if(betEventIds[id]) {
        hits[id] = true
      }
    })
  })

  return { hits, betEventIds }
}

export const Coupons = connect(
  (state, ownProps) => {
    const { playerId } = ownProps.params
    const { date } = ownProps.location.query
    const key = pathNameKeygen({state, ownProps})

    const bets = get(state, ['pagination', 'bets', key])
    const recommendations = get(state, ['pagination', 'betRecommendations', key])
    const { hits, betEventIds } = calculateHits(state, bets, recommendations)

    return {
      playerId: playerId,
      player: state.entities.players[playerId],
      date: moment(date).utc(),
      location: ownProps.location,
      hits,
      totalBets: keys(betEventIds).length
    }
  },
  { loadCouponRecommendations, refreshItems }
)(CouponsPage)


// WEBPACK FOOTER //
// ./src/components/Players/Coupons.js